import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import global from '@/utils/global.js'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueSlideoutPanel from 'vue2-slideout-panel'
//import VueYouTubeEmbed from "vue-youtube-embed";
//import Sortable from "vue-sortable";
//import VuetifyNumberInput from "@jzolago/vuetify-number-input";
import '@/assets/brand.scss'
import '@/assets/custom.scss'
import '@/assets/style-new.scss'
import '@/assets/responsive.scss'
import 'vue-snotify/styles/material.css'
// import vueKanban from "vue-kanban";
// import VueLazyLoad from 'vue-lazyload';
import Vue2Editor from 'vue2-editor'
import VueObserverVisibility from 'vue-observe-visibility'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import { IMPROVE_CONFIG } from '@/config.js'
import VueDraggableResizable from 'vue-draggable-resizable'

// NEW: theme helpers (works now, and with API later)
import {
  applyTheme,
  loadCachedTheme,
  saveCachedTheme,
  fetchThemeFromApi,
} from './theme'

Vue.config.productionTip = false
Vue.prototype.$gf = global
Vue.prototype.$globalConfig = IMPROVE_CONFIG

const options = {
  toast: {
    position: SnotifyPosition.centerTop,
    bodyMaxLength: 180,
  },
}

Vue.router = router

Vue.use(Snotify, options)
Vue.use(VueSlideoutPanel)
Vue.use(Vue2Editor)
Vue.use(VueObserverVisibility)
Vue.use(CKEditor)
Vue.component('vue-draggable-resizable', VueDraggableResizable)

// 1) Apply cached theme immediately (if any) to avoid a flash
const cached = loadCachedTheme()
if (cached) applyTheme(vuetify, cached)

// 2) Mount the app
const app = new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
})
.$mount('#app');

// 3) Try fetching the theme from the API (non-blocking).
//    If the backend isn’t ready, this is a no-op and the app stays on defaults/cached theme.
/*(async () => {
  try {
    const remote = await fetchThemeFromApi()
    if (remote && JSON.stringify(remote) !== JSON.stringify(cached)) {
      applyTheme(vuetify, remote)
      saveCachedTheme(remote)
    }
  } catch {
    // Silent: API not live or failed — keep defaults/cached theme.
  }
})()*/
